import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { Col, Container, SpicyButton, Text } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";

export default function NotFoundPage() {
  return (
    <>
      <PageStaticMetaTags pageId="notFound" prerenderStatusCode={404} />
      <section className="section-404 absolute top-[45%] left-[50%] translate-x-[-50%] translate-y-[-50%] flex flex-col items-center justify-center max-xs:p-2.5">
        <Container>
          <Text h1>404</Text>
        </Container>
        <Col>
          <Text h2>
            <Trans i18nKey="common:notFound.title" />
          </Text>
          <Text h4>
            <Trans i18nKey="common:notFound.description" />
          </Text>
          <LocalizedLink className="mt-3" to="/" aria-label="home">
            <SpicyButton variant="primary_large" color="primary_strong">
              <Trans i18nKey="common:notFound.cta.backToHome" />
            </SpicyButton>
          </LocalizedLink>
        </Col>
      </section>
    </>
  );
}
